// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202606301126/js/" + chunkId + "." + {"44":"344d3876","225":"e5bdf748","481":"090a009f","486":"a3bdbcce","770":"e57f058b"}[chunkId] + ".0.6551232961726193.chunk.js";
};